import theme from "@/theme";
import { Box, Typography } from "@mui/material";
import { FC } from "react";

interface TitleBlockProps {
  title: string;
  subtitle?: string;
}

const TitleBlock: FC<TitleBlockProps> = ({ title, subtitle }) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: "6px" }}>
    <Typography
      component="h1"
      variant="h2"
      fontFamily="Inter"
      lineHeight="26px"
      fontSize="22px"
      fontWeight={600}
      textAlign="center"
      color={theme.palette.custom.mainBlack}
    >
      {title}
    </Typography>

    {subtitle && (
      <Typography
        variant="h4"
        fontFamily="Inter"
        lineHeight="22px"
        fontSize="16px"
        fontWeight={500}
        textAlign="center"
        sx={{ color: "#7D8690" }}
      >
        {subtitle}
      </Typography>
    )}
  </Box>
);

export default TitleBlock;
